import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AsyncPipe, NgClass } from '@angular/common';
import { filter, take } from 'rxjs';
import { SidebarHeaderComponent } from '@app/framework/interaction-bar/sidebar-header/sidebar-header.component';
import { PrimeContactChangeOrderGeneralSidebarComponent } from '@app/framework/interaction-bar/prime-commitments/prime-contract-change-order/prime-contact-change-order-general-sidebar/prime-contact-change-order-general-sidebar.component';
import { SimpleButtonComponent } from '@app/framework/buttons/simple-medium-button/simple-button.component';
import {
  CORLogItem,
  PrimeChangeOrderModel,
} from '@app/store/prime-commitments/prime-commitments.types';
import { PrimeChangeOrderCorSelectComponent } from '@app/framework/interaction-bar/prime-commitments/prime-contract-change-order/prime-contact-change-order-general-sidebar/prime-change-order-cor-select/prime-change-order-cor-select.component';
import { MoneyPipe } from '@app/pipes/framework/money-short.pipe';
import {
  primeDetailsSelectors,
  primeSelectors,
} from '@app/store/prime-commitments/prime-commitments.selectors';
import { PageLoadingComponent } from '@app/framework/page-loading/page-loading.component';
import { DeepCopyService } from '@app/services/deep-copy.service';
import { pccoActions } from '@app/store/prime-commitments/prime-commitments.actions';

@Component({
  selector: 'app-prime-contract-change-order-sidebar',
  imports: [
    SidebarHeaderComponent,
    PrimeContactChangeOrderGeneralSidebarComponent,
    SimpleButtonComponent,
    PrimeChangeOrderCorSelectComponent,
    MoneyPipe,
    AsyncPipe,
    PageLoadingComponent,
    NgClass,
  ],
  templateUrl: './prime-contract-change-order-sidebar.component.html',
  styleUrl: './prime-contract-change-order-sidebar.component.scss',
})
export class PrimeContractChangeOrderSidebarComponent implements OnInit, OnDestroy {
  @ViewChild('pccoGeneral') pccoGeneral: PrimeContactChangeOrderGeneralSidebarComponent;
  @ViewChild('selectedCORs') selectedCORsComponent: PrimeChangeOrderCorSelectComponent;

  private readonly store = inject(Store);

  isPCCOLoading$ = this.store.select(primeSelectors.selectIsPCCOSidebarLoading);
  primeChangeOrderData$ = this.store.select(primeDetailsSelectors.selectPCCOData);

  currentPage: 1 | 2 = 1;
  corTotal = 0;

  model: PrimeChangeOrderModel = {
    generalData: {
      id: null,
      title: '',
      number: null,
      status: null,
      date: null,
      description: '',
      files: [],
    },
    cors: [],
  };

  ngOnInit() {
    this.store.dispatch(pccoActions.onPCCOSidebarOpen());
    this.primeChangeOrderData$
      .pipe(
        filter((data) => !!data),
        take(1),
      )
      .subscribe((data) => {
        this.model = DeepCopyService.deepCopy(data);
      });
  }

  ngOnDestroy() {
    this.store.dispatch(pccoActions.onPCCOSidebarClose());
  }

  goToPreviousPage() {
    if (this.currentPage === 1) {
      return;
    }
    this.currentPage--;
  }

  onNext() {
    if (!this.pccoGeneral.isValid()) {
      return;
    }
    this.currentPage++;
  }

  saveForm() {
    this.store.dispatch(
      pccoActions.onPCCOSubmit({
        model: {
          ...DeepCopyService.deepCopy(this.model),
        },
      }),
    );
  }

  selectedCORsChanged(selectedCORs: CORLogItem[]) {
    this.model.cors = selectedCORs;
  }
}
